import { createUrl, formatDate, request, textLimit } from 'app/utils';
import { AxiosResponse } from 'axios';
import { Box, Button, Flex, Icons, Loading, Page, Section, Typography } from 'components';
import SubmenuVertical from 'components/submenuVertical';
import { HeaderPerfil } from 'features/account/components';
import { CertificateApiReponse, CertificateItem } from 'features/account/types';
import { useSchool } from 'features/school';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

const WrapperName = styled.div`
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: left;
  width: 90%;
`;

const CertificatesView = () => {
  const navigate = useNavigate();
  const [subAreaIndex, setSubAreaIndex] = useState(0);
  const [certificates, setCertificates] = useState<CertificateItem[]>([]);
  const [loading, setLoading] = useState(true);

  const [isMobile, setIsMobile] = useState(false);

  const { apiGatewayUrl } = useSchool();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetch = async () => {
    setLoading(true);
    await Promise.all([
      request({
        url: `/api/v1/School/MyAccount/Certificates`,
        method: 'get',
        baseURL: apiGatewayUrl,
        data: {
          productSlug: null,
          specialOnly: null,
          itensPerQuery: 8,
        },
      }).then(({ data }: AxiosResponse<CertificateApiReponse>) => {
        setCertificates(data.items);
      }),
    ]).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    fetch();
  }, []);

  if (loading) return <Loading label="Por favor, aguarde." />;

  return (
    <Page title="Meus certificados">
      <HeaderPerfil areaIndex={2} onAreaClick={(value) => navigate(createUrl(value))} />
      <Flex flexDirection="row" bg="white">
        <SubmenuVertical areas={['Certificados']} areaIndex={subAreaIndex} onAreaClick={(index) => setSubAreaIndex(index)} />

        {subAreaIndex === 0 ? (
          <Flex py={{ m: 30, t: 60, d: 60 }} bg="white" flexGrow={0} marginLeft="2%">
            <Section flex={1} flexDirection={{ m: 'column', d: 'row' }} flexWrap="wrap">
              {certificates.length <= 0 && (
                <Flex>
                  <Typography fontWeight="bold">Não há certificados disponiveis</Typography>
                </Flex>
              )}
              {certificates?.map((certificate, index) => {
                return (
                  <Flex flexGrow={0} key={index} mb="4" mr={4}>
                    <Button
                      type="button"
                      paddingY={16}
                      paddingX={16}
                      height="auto"
                      width={isMobile ? 300 : 380}
                      maxHeight={100}
                      bg="black"
                      color="primary_400"
                      colorHover="primary_400"
                      size="small"
                      borderRadius={4}
                      onClick={() => window.open(certificate.certificateDownloadUrl, '_blank')}
                    >
                      <Flex flexDirection="column" alignItems="flex-start">
                        <Typography type="type0" color="primary_400">
                          CONCLUÍDO EM {formatDate(certificate.completedAt).format('DD/MM/YYYY')}
                        </Typography>
                        <Flex mt={2} width="100%" alignItems="center" justifyContent="space-between" flexDirection="row">
                          <WrapperName>
                            <Typography type="type2" color="white">
                              {textLimit(certificate.productName, 60)}
                            </Typography>
                          </WrapperName>
                          <Flex justifyContent="flex-end">
                            <Icon icon="chevronRight" />
                          </Flex>
                        </Flex>
                      </Flex>
                    </Button>
                  </Flex>
                );
              })}
            </Section>
          </Flex>
        ) : null}
      </Flex>
    </Page>
  );
};

export default CertificatesView;
